// extracted by mini-css-extract-plugin
export default {"link":"style_link__C4Ngv","centerGrid":"style_centerGrid__C3ohK","img":"style_img__N94rs","namegame":"style_namegame__tFOQ1","center":"style_center__lE-+O"};